
const checkBoxFontSize = 12;
const fieldFontSize = 14;

export const styles = (theme) => ({
  paperWidthMd: {
    width: '40%',
    overflow: 'visible',
  },
  scrollPaperTablet: {
    alignItems: 'baseline',
  },
  panel: {
    padding: '10px 20px 10px 20px',
    background: theme.palette.greyScale[7],
    overflow: 'visible',
  },
  textField: {
    '& label.Mui-focused': {
      color: theme.palette.greyScale[0],
    },
    '& label': {
      color: theme.palette.greyScale[0],
    },

    '& input': {
      fontSize: fieldFontSize,
      paddingBottom: 4,
      '&::placeholder': {
        color: 'black',
        opacity: '100%',
      },
    },
  },
  clrSection: {
    display: 'flex',
    height:24,
    alignItems: 'center',
    border: 'none',
    marginTop: 12,
    background: theme.palette.greyScale[7],
    color: 'black',
    fontSize: '13px',
  },
  editSection: {
    background: theme.palette.greyScale[7],
    color: 'black',
    fontSize: '13px',
    height: 56,
    width: '100%',
    borderBottomStyle: 'solid',
    borderRadius: 0,
    borderBottomWidth: 'thin',
    borderColor: theme.palette.greyScale[6],
  },
  icon: {
    paddingRight: 12,
    width:'30px',
  },
  splitsContainer: {
    marginBottom: 15,
    marginLeft: 24,
    marginRight: 24,
    background: theme.palette.greyScale[7],
    overflow: 'visible',
  },
  inputLabel: {
    fontSize: fieldFontSize,
    '& label.Mui-focused': {
      color: 'black',
    },
    '& label': {
      color: 'black',
    },
    // color: 'black',
    '&::placeholder': {
      color: 'black',
      opacity: '100%',
    },
  },
  formLabel: {
    height: 20,
    marginLeft: 0,
  },
  checkboxLabel: {
    fontSize: checkBoxFontSize,
    color: theme.palette.greyScale[2],
    marginLeft: 5,
  },
  checkbox: {
    fontSize: checkBoxFontSize + 6,
    paddingBottom: 3,
    height: 30,
    marginTop: 10,
  },
  categoryField: {
    fontSize: fieldFontSize,
    '& input': {
      width: '95%',
      paddingBottom: 1,
      '& label.Mui-focused': {
        color: 'black',
      },
      '& label': {
        color: 'black',
      },
      '&::placeholder': {
        color: 'black',
        opacity: '100%',
      },
    },
  },
  categoryFieldSection: {
    background: theme.palette.greyScale[7],
    color: 'black',
    fontSize: '15px',
    width: '100% !important',
    display: 'flex',
    height: 56,
    borderBottomStyle: 'solid',
    borderRadius: 0,
    borderBottomWidth: 'thin',
    borderColor: theme.palette.greyScale[6],
  },
  buttonHolder: {
    textAlign: 'right',
    margin: 'auto',
    marginTop: '10px',
    background: theme.palette.greyScale[7],
    padding: 24,
    paddingTop: 0,
  },
  disclaimer: {
    fontSize: '11px',
    color: theme.palette.greyScale[2],
  },
  headerTitle: {
    display: 'flex',
    padding: 24,
    alignItems: 'center',
    backgroundColor: theme.palette.grey.level1,
    justifyContent: 'space-between',
    borderRadius: '8px 8px 0 0',
  },
  closeButtonTop: {
    padding: 0,
  },
});


